import axios from "common/helpers/axios.helper"

const reportError = (error) => {
    if (error.response) {
        if (error.response.status === 401) {
            console.log('ERROR(response): status: 401 -> Session ist abgelaufen', error.response)
        } else {
            console.log('ERROR(response): Ein Fehler ist aufgetreten!', error.response)
        }

    } else if (error.request) {
        console.log('ERROR(request)', error.request)
    } else {
        console.log('ERROR(request) setup?', error.message)
    }
}

export const initUser = (data, modalDialog) => {
    return (dispatch, getState) => {
        dispatch({ type: 'USER_INIT', payload: data });
        if (modalDialog) {
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: modalDialog, type: 'create' } });
        }
    }
}

export const logoutUser = () => {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_TOKEN', payload: '' });
        dispatch({ type: 'USER_LOGOUT' });
    }
}

export const loginUser = (data) => {
    return (dispatch, getState) => {
        const { apiURL } = getState().app;

        dispatch({ type: 'USER_LOGIN_PENDING' });

        axios({
            url: encodeURI(apiURL + '/api/v1/users/login'),
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'SET_TOKEN', payload: 'Bearer ' + response.data.token });
            dispatch({ type: 'USER_LOGIN_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'USER_LOGIN_ERROR', payload: error.response });
        });
    }
}

export const getUserList = () => {
    return (dispatch, getState) => {
        const { apiURL, token } = getState().app;

        dispatch({ type: 'USER_LIST_PENDING' });

        axios({
            url: encodeURI(apiURL + '/api/v1/users'),
            method: 'GET',
            responseType: 'json',
            headers: { 'authorization': token, 'Content-Type': 'application/json' }
        }).then((response) => {
            dispatch({ type: 'USER_LIST_SUCCESS', payload: response.data });
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'USER_LIST_ERROR', payload: error.response })
        });
    }
}

export const getUser = (id, modalDialog = null, modalType = null) => {
    return (dispatch, getState) => {
        const { apiURL, token } = getState().app;

        dispatch({ type: 'USER_SELECT_PENDING' });

        axios({
            url: encodeURI(apiURL + '/api/v1/users/id/' + id),
            method: 'GET',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'USER_SELECT_SUCCESS', payload: response.data });
            if (modalDialog) {
                dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: modalDialog, type: modalType } });
            }
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'USER_SELECT_ERROR', payload: error.response })
        });
    }
}

export const createUser = (data) => {
    return (dispatch, getState) => {
        const { apiURL, token } = getState().app;

        dispatch({ type: 'USER_CREATE_PENDING' });

        axios({
            url: encodeURI(apiURL + '/api/v1/users'),
            method: 'POST',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'USER_CREATE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getUserList())
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'USER_CREATE_ERROR', payload: error.response })
        });
    }
}

export const updateUser = (id, data) => {
    return (dispatch, getState) => {
        const { apiURL, token } = getState().app;

        if (data.action === 'created') {
            data['action'] = 'activated';
        }

        dispatch({ type: 'USER_UPDATE_PENDING' });

        axios({
            url: encodeURI(apiURL + '/api/v1/users/id/' + id),
            method: 'PATCH',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'USER_UPDATE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getUserList())
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'USER_UPDATE_ERROR', payload: error.response })
        });
    }
}

export const deleteUser = (id) => {
    return (dispatch, getState) => {
        const { apiURL, token } = getState().app;

        dispatch({ type: 'USER_DELETE_PENDING' });

        axios({
            url: encodeURI(apiURL + '/api/v1/users/id/' + id),
            method: 'DELETE',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'USER_DELETE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getUserList())
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'USER_DELETE_ERROR', payload: error.response })
        });
    }
}
